import * as d3 from 'd3';
import reduce from 'lodash/reduce';

export const getElementsMapByDataAid = (selector: string) => {
  const elements: any = d3.selectAll(selector);
  return reduce(
    elements._groups[0],
    (acc: { [key: string]: any }, element) => {
      if (!element) {
        return acc;
      }
      const elementDataAid = element.getAttribute('data-aid');

      if (elementDataAid) {
        acc[elementDataAid] = element;
      }
      return acc;
    },
    {}
  );
};
